import { SectionCard } from "@/features/identity/components/SectionCard";
import { SaveBar } from "@/features/identity/components/SaveBar";
import { LinksManager } from "@/features/identity/components/LinksManager";
import { MediaUploader } from "@/features/identity/components/MediaUploader";
import { useSectionForm } from "@/features/identity/hooks/useSectionForm";
import { useLinksEditor } from "@/features/identity/hooks/useLinksEditor";

export function EditorFormSection({ section }) {
  const form = useSectionForm(section);
  const { Component } = section;
  return (
    <SectionCard
      title={section.title}
      description={section.description}
      testId={`editor-${section.key}-section`}
      footer={<SaveBar status={form.status} dirty={form.dirty} onSave={() => form.submit()} testId={`editor-${section.key}`} />}
    >
      <form onSubmit={(e) => { e.preventDefault(); form.submit(); }} noValidate>
        <Component form={form} />
      </form>
    </SectionCard>
  );
}

export function EditorLinksSection() {
  const editor = useLinksEditor();
  return (
    <SectionCard
      title="Links"
      description="Profiles people can find you on. Reorder, hide or remove any time."
      testId="editor-links-section"
      footer={<SaveBar status={editor.status} dirty={editor.dirty} onSave={editor.save} testId="editor-links" />}
    >
      <LinksManager editor={editor} />
    </SectionCard>
  );
}

export function EditorMediaSection() {
  return (
    <SectionCard title="Photo & logo" description="Changes save as soon as an upload finishes." testId="editor-media-section">
      <div className="space-y-8">
        <MediaUploader kind="photo" />
        <div className="h-px bg-border" />
        <MediaUploader kind="logo" />
      </div>
    </SectionCard>
  );
}
